var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavigationPrimary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 115402"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 109845",
    d: "M16.5636 0.555583C16.471 0.462552 16.3528 0.39911 16.2241 0.373296C16.0954 0.347483 15.9619 0.36046 15.8406 0.410583L1.27659 6.36858C1.14407 6.4228 1.03269 6.51851 0.959168 6.64138C0.885646 6.76425 0.853944 6.90765 0.868816 7.05006C0.883688 7.19247 0.944333 7.32622 1.04165 7.43125C1.13898 7.53628 1.26773 7.60692 1.40859 7.63258L8.24059 8.87458L9.48359 15.7056C9.50919 15.8464 9.57973 15.9752 9.68466 16.0725C9.78959 16.1699 9.92324 16.2306 10.0656 16.2456C10.0886 16.2456 10.1116 16.2456 10.1346 16.2456C10.2661 16.2455 10.3946 16.2062 10.5038 16.1328C10.6129 16.0595 10.6978 15.9553 10.7476 15.8336L16.7046 1.27358C16.7543 1.1533 16.7674 1.02103 16.7423 0.893332C16.7172 0.76563 16.6551 0.648152 16.5636 0.555583Z",
    fill: "url(#paint0_linear_1_2812)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2812",
    x1: 8.80998,
    y1: 0.360352,
    x2: 8.80998,
    y2: 16.2456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4584E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CC19C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationPrimary);
export default __webpack_public_path__ + "static/media/navigation-primary.8d45c78275e51353f830afd53cf683ca.svg";
export { ForwardRef as ReactComponent };